import React from 'react';
import apiDomainService from '../../../../services/apiDomainService';

const RuleAttachmentViewer = ({ attachment }) => {
  if (!attachment || !attachment.fileUrl) {
    return null;
  }

  const { fileUrl, fileType, fileName } = attachment;
  // Construct full URL using domain service if the API returns a relative path
  const fullUrl = fileUrl.startsWith('http') ? fileUrl : `${apiDomainService.replaceSubdomain()}${fileUrl}`;
  
  const isImage = fileType && fileType.startsWith('image/');
  const isPdf = fileType === 'application/pdf';

  return (
    <div className="mt-4 border rounded-lg overflow-hidden bg-gray-50 p-4">
      <div className="flex items-center justify-between mb-3">
        <h4 className="text-sm font-semibold text-gray-700 flex items-center">
          <svg className="w-5 h-5 mr-2 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
          </svg>
          Attachment: {fileName || 'Document'}
        </h4>
        <a 
          href={fullUrl} 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-xs font-medium text-white bg-indigo-600 hover:bg-indigo-700 px-3 py-1.5 rounded shadow transition-colors"
        >
          Download
        </a>
      </div>
      
      <div className="bg-white border rounded shadow-inner flex items-center justify-center min-h-[200px] overflow-hidden">
        {isImage ? (
          <img src={fullUrl} alt={fileName} className="max-w-full h-auto object-contain max-h-[500px]" />
        ) : isPdf ? (
          <object data={fullUrl} type="application/pdf" className="w-full h-[500px]">
            <p className="text-sm text-gray-500 p-4">
              Your browser does not support PDFs. 
              <a href={fullUrl} className="text-indigo-600 hover:underline ml-1">Download the PDF</a>.
            </p>
          </object>
        ) : (
          <div className="text-center p-8 text-gray-500">
            <svg className="w-12 h-12 mx-auto mb-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <p className="text-sm">Preview not available for this file type.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RuleAttachmentViewer;
